export const TOAST_TIMEOUT = 10000;
